import { searchSetQuery } from '@features/search/model/actions.js';
import { useAppSelector } from '@shared/hooks/useAppSelector.js';
import { isEventOnMap } from '@shared/mapUtils.js';
import type { LatLon } from '@shared/types/common.js';
import type { LeafletMouseEvent } from 'leaflet';
import { type ReactElement, useCallback, useState } from 'react';
import { Circle, useMapEvent } from 'react-leaflet';
import { useDispatch } from 'react-redux';

export function MapDetailsTool(): ReactElement | null {
  const dispatch = useDispatch();

  const [latLon, setLatLon] = useState<LatLon>();

  useMapEvent(
    'click',
    useCallback(
      (e: LeafletMouseEvent) => {
        dispatch(
          searchSetQuery({
            query:
              '@' + e.latlng.lat.toFixed(6) + ',' + e.latlng.lng.toFixed(6),
          }),
        );
      },
      [dispatch],
    ),
  );

  useMapEvent(
    'mousemove',
    useCallback(({ latlng, originalEvent }: LeafletMouseEvent) => {
      setLatLon(
        isEventOnMap(originalEvent)
          ? { lat: latlng.lat, lon: latlng.lng }
          : undefined,
      );
    }, []),
  );

  useMapEvent(
    'mouseout',
    useCallback(() => {
      setLatLon(undefined);
    }, []),
  );

  const hasNearby = useAppSelector(
    (state) => !state.mapDetails.excludeSources.includes('overpass-nearby'),
  );

  return latLon && hasNearby ? (
    <Circle
      interactive={false}
      center={[latLon.lat, latLon.lon]}
      radius={33}
      stroke={false}
    />
  ) : null;
}
